export default __webpack_public_path__ + "asset/afghanistan.a3294835a57c599d351161dc8b7fa4d1.svg";